import {Component, Input, OnInit} from "@angular/core";
import {DbActiveModal} from "../../../../../modules/modal/modal-ref";
import * as fromStore from '../../../../../store';
import {distinctUntilChanged, filter} from "rxjs/operators";
import {TypeUtils} from "../../../../../shared/utils/type-utils";
import {Store} from "@ngrx/store";

@Component({
    selector: 'db-add-domain-success-dialog',
    templateUrl: './add-domain-success-dialog.component.html',
    styleUrls: ['./add-domain-success-dialog.component.scss'],
    standalone: false
})
export class AddDomainSuccessDialogComponent implements OnInit {


  @Input() domainZoneID?: string;
  @Input() fromDetails = false;
  @Input() isTenWebNS?: boolean;
  @Input() isDomainPointed?: boolean;
  @Input() isTenWebDomain?: boolean;
  @Input() domainName?: string;
  @Input() ipv4Address?: string;
  @Input() zoneIssues?: boolean = false;

  public isTextCopied: any = [];
  public nameServers?: string[];
  public nsLoading: boolean = true;

  constructor(
    private readonly _activeModal: DbActiveModal,
    private _store: Store<fromStore.DbStoreState>,
  ) {
  }

  ngOnInit() {
    if (this.domainZoneID) {
      this._loadDomainsAvailableZones(this.domainZoneID);
    } else {
      this.nsLoading = false;
    }
  }

  private _loadDomainsAvailableZones(domainZoneID: string): void {
    this._store.dispatch(new fromStore.LoadZone({zoneId: domainZoneID}));

    this._store
      .select(fromStore.getZone(domainZoneID))
      .pipe(
        filter((zone: any) => !!zone),
        distinctUntilChanged(),
      )
      .subscribe((zone: any) => {
        if (zone && !TypeUtils.isEmpty(zone)) {
          this.nameServers = zone && zone.zone && zone.zone.nameservers;
          this.nsLoading = false;
        }
      });
  }

  public copied(index: any) {
    this.isTextCopied[index] = true;
    setTimeout(() => this.isTextCopied[index] = false, 800);
  }

  public closeModal(): void {
    this._activeModal.close();
  }
}
